const scheduleTypes = {
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
};

export default scheduleTypes;
